import {
  IconUsers, IconDashboard, IconBlogs, IconWarehouse, IconCompatibility, IconPrinter, IconEbayLogo,
  IconAbs, IconSetting
} from '../assets/icon';
import routes from '../router/routes';

const sideBarContent = [
  {
    id: 1,
    title: 'Dashboard',
    Icon: IconDashboard,
    isOpen: false,
    path: routes.DASHBOARD
  },
  {
    id: 2,
    title: 'User Management',
    Icon: IconUsers,
    isOpen: false,
    list: [
      {
        id: 21,
        title: 'Roles',
        path: routes.ROLES,
      },
      {
        id: 22,
        title: 'Users',
        path: routes.USERS,
      },
      {
        id: 25,
        title: 'Service Tokens',
        path: routes.SERVICE_TOKENS,
        adminOnly: true,
      },
      {
        id: 23,
        title: 'User Logs',
        path: routes.USER_LOGS,
      },
      {
        id: 24,
        title: 'Supplier API Logs',
        path: routes.SUPPLIER_API_LOGS,
      },
    ]
  },
  {
    id: 4,
    title: 'Coilovers warehouse',
    Icon: IconWarehouse,
    isOpen: false,
    list: [
      {
        id: 41,
        title: 'Acceptance',
        path: routes.ACCEPTANCE,
      },
      {
        id: 42,
        title: 'Ordered Parts',
        path: routes.CO_ORDERED_PARTS,
      },
      {
        id: 43,
        title: 'Warehouse',
        path: routes.CO_WAREHOUSE,
      },
      {
        id: 44,
        title: 'Orders',
        path: routes.CO_ORDERS,
      }
    ]
  },
  {
    id: 5,
    title: 'Articles',
    Icon: IconBlogs,
    isOpen: false,
    path: routes.ARTICLES
  },
  {
    id: 6,
    title: 'Compatibility',
    Icon: IconCompatibility,
    isOpen: false,
    path: routes.COMPATIBILITY
  },
  {
    id: 7,
    title: 'Printer Tasks',
    Icon: IconPrinter,
    isOpen: false,
    path: routes.PRINTER
  },
  {
    id: 8,
    title: 'Ebay',
    Icon: IconEbayLogo,
    isOpen: false,
    list: [
      {
        id: 81,
        title: 'Tasks',
        path: routes.EBAY_TASKS,
      },
    ],
  },
  {
    id: 9,
    title: 'Jobs',
    Icon: IconAbs,
    isOpen: false,
    list: [
      {
        id: 91,
        title: 'In progress',
        path: routes.JOBS_IN_PROGRESS,
      },
      {
        id: 92,
        title: 'Failed',
        path: routes.JOBS_FAILED,
      },
      {
        id: 93,
        title: 'Failed Import Rows',
        path: routes.JOBS_FAILED_IMPORT_ROWS,
      },
    ],
  },
  {
    id: 3,
    title: 'Supplier Settings',
    Icon: IconSetting,
    isOpen: false,
    path: routes.SUPPLIER_SETTINGS
  },
];

export default sideBarContent;
